<div class="row" *ngIf="isComercial || isBasica">
    <div class="col-lg col-md col-xs col-xl col-sm w-100">
        <mat-card class="mat-elevation-z8 w-100">
            <form [formGroup]="formulario">
                <div class="row">
                    <div class="col-lg col-md col-xs col-xl col-sm">
                        <p class="tituloLeft">{{step}}</p>
                    </div>
                    <div class="col-lg-2 col-md-2 col-xs-2 col-xl-2 col-sm-2 text-right">
                        <i class="fa fa-window-minimize iconMenu" matTooltip="Minimizar" (click)="changeCollapse()"
                            *ngIf="!collapseCard"></i>
                        <i class="fa fa-window-maximize iconMenu" matTooltip="Maximizar" (click)="changeCollapse()"
                            *ngIf="collapseCard"></i>
                    </div>
                </div>
                <mat-card-content *ngIf="!collapseCard">
                    <div class="row pt-3">
                        <div class="col-lg col-md">
                            <mat-form-field class="w-100" appearance="{{formFieldAppearance}}"
                                floatLabel="{{formFieldFloatLabel}}">
                                <mat-label class="InputLabelColor">Status WWB</mat-label>
                                <input matInput id="txtStatus_wwb" #txtStatus_wwb maxlength="25"
                                    formControlName="Status_wwb" readonly class="InputBlockColor">
                                <i matSuffix class="{{iconDisableField}}"></i>
                                <mat-hint align="start" class="InputLabelDetailsColor">{{hintCalc}}</mat-hint>
                                <mat-hint align="end">{{txtStatus_wwb.value.length}} / 25</mat-hint>
                                <mat-error>{{hasErrorFormControl(formulario.controls.Status_wwb)}}
                                </mat-error>
                            </mat-form-field>
                        </div>
                        <div class="col-lg col-md">
                            <mat-form-field class="w-100" appearance="{{formFieldAppearance}}"
                                floatLabel="{{formFieldFloatLabel}}">
                                <mat-label class="InputLabelColor"> Peso da amostra (g)
                                </mat-label>
                                <input matInput id="txtPeso_amostra_g" #txtPeso_amostra_g maxlength="10"
                                    formControlName="Peso_amostra_g" readonly class="InputBlockColor" currencyMask>
                                <i matSuffix class="{{iconDisableField}}"></i>
                                <mat-hint align="start" class="InputLabelDetailsColor">{{hintCalc}}</mat-hint>
                                <mat-hint align="end">{{txtPeso_amostra_g.value.length}} / 10</mat-hint>
                                <mat-error>{{hasErrorFormControl(formulario.controls.Peso_amostra_g)}}
                                </mat-error>
                            </mat-form-field>
                        </div>
                        <div class="col-lg col-md">
                            <mat-form-field class="w-100" appearance="{{formFieldAppearance}}"
                                floatLabel="{{formFieldFloatLabel}}">
                                <mat-label class="InputLabelColor">Peso da palha + impureza (g)</mat-label>
                                <input matInput id="txtPeso_palha_imp_g" #txtPeso_palha_imp_g maxlength="10"
                                    formControlName="Peso_palha_imp_g" currencyMask (blur)="makeCalculations()"
                                    [options]="{ thousands: '.', decimal: ',', precision: 2 }">
                                <i matSuffix class="{{iconEnableField}}"></i>
                                <mat-hint align="start" class="InputLabelDetailsColor">{{hintNumber}}</mat-hint>
                                <mat-hint align="end">{{txtPeso_palha_imp_g.value.length}} / 10</mat-hint>
                                <mat-error>{{hasErrorFormControl(formulario.controls.Peso_palha_imp_g)}}
                                </mat-error>
                            </mat-form-field>
                        </div>
                        <div class="col-lg col-md">
                            <mat-form-field class="w-100" appearance="{{formFieldAppearance}}"
                                floatLabel="{{formFieldFloatLabel}}">
                                <mat-label class="InputLabelColor">Peso dos grãos debulhados (g)</mat-label>
                                <input matInput id="txtPeso_graos_debulhados_g" #txtPeso_graos_debulhados_g
                                    maxlength="10" formControlName="Peso_graos_debulhados_g" currencyMask
                                    (blur)="makeCalculations()"
                                    [options]="{ thousands: '.', decimal: ',', precision: 2 }">
                                <i matSuffix class="{{iconEnableField}}"></i>
                                <mat-hint align="start" class="InputLabelDetailsColor">{{hintNumber}}</mat-hint>
                                <mat-hint align="end">{{txtPeso_graos_debulhados_g.value.length}} / 10</mat-hint>
                                <mat-error>{{hasErrorFormControl(formulario.controls.Peso_graos_debulhados_g)}}
                                </mat-error>
                            </mat-form-field>
                        </div>
                    </div>
                    <div class="row pt-3">
                        <div class="col-lg col-md">
                            <mat-form-field class="w-100" appearance="{{formFieldAppearance}}"
                                floatLabel="{{formFieldFloatLabel}}">
                                <mat-label class="InputLabelColor">Peso dos grãos de espigas inteiras (g)</mat-label>
                                <input matInput id="txtPeso_graos_espigas_inteiras_g" #txtPeso_graos_espigas_inteiras_g
                                    maxlength="10" formControlName="Peso_graos_espigas_inteiras_g" currencyMask
                                    (blur)="makeCalculations()"
                                    [options]="{ thousands: '.', decimal: ',', precision: 2 }">
                                <i matSuffix class="{{iconEnableField}}"></i>
                                <mat-hint align="start" class="InputLabelDetailsColor">{{hintNumber}}</mat-hint>
                                <mat-hint align="end">{{txtPeso_graos_espigas_inteiras_g.value.length}} / 10</mat-hint>
                                <mat-error>{{hasErrorFormControl(formulario.controls.Peso_graos_espigas_inteiras_g)}}
                                </mat-error>
                            </mat-form-field>
                        </div>
                        <div class="col-lg col-md">
                            <mat-form-field class="w-100" appearance="{{formFieldAppearance}}"
                                floatLabel="{{formFieldFloatLabel}}">
                                <mat-label class="InputLabelColor"> Palha do CERAR (%)
                                </mat-label>
                                <input matInput id="txtPalha_cerar" #txtPalha_cerar maxlength="10"
                                    formControlName="Palha_cerar" readonly class="InputBlockColor" currencyMask>
                                <i matSuffix class="{{iconDisableField}}"></i>
                                <mat-hint align="start" class="InputLabelDetailsColor">{{hintCalc}}</mat-hint>
                                <mat-hint align="end">{{txtPalha_cerar.value.length}} / 10</mat-hint>
                                <mat-error>{{hasErrorFormControl(formulario.controls.Palha_cerar)}}
                                </mat-error>
                            </mat-form-field>
                        </div>
                        <div class="col-lg col-md">
                            <mat-form-field class="w-100" appearance="{{formFieldAppearance}}"
                                floatLabel="{{formFieldFloatLabel}}">
                                <mat-label class="InputLabelColor"> Sabugo do CERAR (%)
                                </mat-label>
                                <input matInput id="txtSabugo_cerar" #txtSabugo_cerar maxlength="10"
                                    formControlName="Sabugo_cerar" readonly class="InputBlockColor" currencyMask>
                                <i matSuffix class="{{iconDisableField}}"></i>
                                <mat-hint align="start" class="InputLabelDetailsColor">{{hintCalc}}</mat-hint>
                                <mat-hint align="end">{{txtSabugo_cerar.value.length}} / 10</mat-hint>
                                <mat-error>{{hasErrorFormControl(formulario.controls.Sabugo_cerar)}}
                                </mat-error>
                            </mat-form-field>
                        </div>
                        <div class="col-lg col-md">
                            <mat-form-field class="w-100" appearance="{{formFieldAppearance}}"
                                floatLabel="{{formFieldFloatLabel}}">
                                <mat-label class="InputLabelColor"> Semente do CERAR (%)
                                </mat-label>
                                <input matInput id="txtSemente_cerar" #txtSemente_cerar maxlength="10"
                                    formControlName="Semente_cerar" readonly class="InputBlockColor" currencyMask>
                                <i matSuffix class="{{iconDisableField}}"></i>
                                <mat-hint align="start" class="InputLabelDetailsColor">{{hintCalc}}</mat-hint>
                                <mat-hint align="end">{{txtSemente_cerar.value.length}} / 10</mat-hint>
                                <mat-error>{{hasErrorFormControl(formulario.controls.Semente_cerar)}}
                                </mat-error>
                            </mat-form-field>
                        </div>
                    </div>
                    <div class="row pt-3">
                        <div class="col-lg col-md">
                            <mat-form-field class="w-100" appearance="{{formFieldAppearance}}"
                                floatLabel="{{formFieldFloatLabel}}">
                                <mat-label class="InputLabelColor"> Palha da amostra (%)
                                </mat-label>
                                <input matInput id="txtPalha_amostra" #txtPalha_amostra maxlength="10"
                                    formControlName="Palha_amostra" readonly class="InputBlockColor" currencyMask>
                                <i matSuffix class="{{iconDisableField}}"></i>
                                <mat-hint align="start" class="InputLabelDetailsColor">{{hintCalc}}</mat-hint>
                                <mat-hint align="end">{{txtPalha_amostra.value.length}} / 10</mat-hint>
                                <mat-error>{{hasErrorFormControl(formulario.controls.Palha_amostra)}}
                                </mat-error>
                            </mat-form-field>
                        </div>
                        <div class="col-lg col-md">
                            <mat-form-field class="w-100" appearance="{{formFieldAppearance}}"
                                floatLabel="{{formFieldFloatLabel}}">
                                <mat-label class="InputLabelColor"> Total grãos perdidos amostra (%)
                                </mat-label>
                                <input matInput id="txtTotal_graos_perdidos_amostra" #txtTotal_graos_perdidos_amostra
                                    maxlength="10" formControlName="Total_graos_perdidos_amostra" readonly
                                    class="InputBlockColor" currencyMask>
                                <i matSuffix class="{{iconDisableField}}"></i>
                                <mat-hint align="start" class="InputLabelDetailsColor">{{hintCalc}}</mat-hint>
                                <mat-hint align="end">{{txtTotal_graos_perdidos_amostra.value.length}} / 10</mat-hint>
                                <mat-error>{{hasErrorFormControl(formulario.controls.Total_graos_perdidos_amostra)}}
                                </mat-error>
                            </mat-form-field>
                        </div>
                        <div class="col-lg col-md">
                            <mat-form-field class="w-100" appearance="{{formFieldAppearance}}"
                                floatLabel="{{formFieldFloatLabel}}">
                                <mat-label class="InputLabelColor"> Perda por espigas inteiras (%)
                                </mat-label>
                                <input matInput id="txtPerda_por_espigas_inteiras" #txtPerda_por_espigas_inteiras
                                    maxlength="10" formControlName="Perda_por_espigas_inteiras" readonly
                                    class="InputBlockColor" currencyMask>
                                <i matSuffix class="{{iconDisableField}}"></i>
                                <mat-hint align="start" class="InputLabelDetailsColor">{{hintCalc}}</mat-hint>
                                <mat-hint align="end">{{txtPerda_por_espigas_inteiras.value.length}} / 10</mat-hint>
                                <mat-error>{{hasErrorFormControl(formulario.controls.Perda_por_espigas_inteiras)}}
                                </mat-error>
                            </mat-form-field>
                        </div>
                    </div>


                </mat-card-content>
            </form>
        </mat-card>
    </div>
</div>

<div class="row" *ngIf="isPreBasica">
    <div class="col-lg col-md col-xs col-xl col-sm w-100">
        <mat-card class="mat-elevation-z8 w-100">
            <form [formGroup]="formulario">
                <div class="row">
                    <div class="col-lg col-md col-xs col-xl col-sm">
                        <p class="tituloLeft">{{step}}</p>
                    </div>
                    <div class="col-lg-2 col-md-2 col-xs-2 col-xl-2 col-sm-2 text-right">
                        <i class="fa fa-window-minimize iconMenu" matTooltip="Minimizar" (click)="changeCollapse()"
                            *ngIf="!collapseCard"></i>
                        <i class="fa fa-window-maximize iconMenu" matTooltip="Maximizar" (click)="changeCollapse()"
                            *ngIf="collapseCard"></i>
                    </div>
                </div>
                <mat-card-content *ngIf="!collapseCard">
                    <div class="row pt-3">
                        <div class="col-lg col-md">
                            <mat-form-field class="w-100" appearance="{{formFieldAppearance}}"
                                floatLabel="{{formFieldFloatLabel}}">
                                <mat-label class="InputLabelColor">Ataque de Lagartas
                                    <span class="InputRequired">{{required}}</span></mat-label>
                                <input matInput id="txtAtqLargarta" #txtAtqLargarta maxlength="10"
                                    formControlName="ataque_lagartas" currencyMask
                                    [options]="{ thousands: '.', decimal: ',', precision: 0 }">
                                <i matSuffix class="{{iconEnableField}}"></i>
                                <mat-hint align="start" class="InputLabelDetailsColor">{{hintNumber}}</mat-hint>
                                <mat-hint align="end">{{txtAtqLargarta.value.length}} / 10</mat-hint>
                                <mat-error>{{hasErrorFormControl(formulario.controls.ataque_lagartas)}}
                                </mat-error>
                            </mat-form-field>
                        </div>
                        <div class="col-lg col-md">
                            <mat-form-field class="w-100" appearance="{{formFieldAppearance}}"
                                floatLabel="{{formFieldFloatLabel}}">
                                <mat-label class="InputLabelColor">Diploidia
                                    <span class="InputRequired">{{required}}</span></mat-label>
                                <input matInput id="txtDiploidia" #txtDiploidia maxlength="10"
                                    formControlName="diploidia" currencyMask
                                    [options]="{ thousands: '.', decimal: ',', precision: 0 }">
                                <i matSuffix class="{{iconEnableField}}"></i>
                                <mat-hint align="start" class="InputLabelDetailsColor">{{hintNumber}}</mat-hint>
                                <mat-hint align="end">{{txtDiploidia.value.length}} / 10</mat-hint>
                                <mat-error>{{hasErrorFormControl(formulario.controls.diploidia)}}
                                </mat-error>
                            </mat-form-field>
                        </div>
                        <div class="col-lg col-md">
                            <mat-form-field class="w-100" appearance="{{formFieldAppearance}}"
                                floatLabel="{{formFieldFloatLabel}}">
                                <mat-label class="InputLabelColor">Fusarium
                                    <span class="InputRequired">{{required}}</span></mat-label>
                                <input matInput id="txtFusarium" #txtFusarium maxlength="10" formControlName="fusarium"
                                    currencyMask [options]="{ thousands: '.', decimal: ',', precision: 0 }">
                                <i matSuffix class="{{iconEnableField}}"></i>
                                <mat-hint align="start" class="InputLabelDetailsColor">{{hintNumber}}</mat-hint>
                                <mat-hint align="end">{{txtFusarium.value.length}} / 10</mat-hint>
                                <mat-error>{{hasErrorFormControl(formulario.controls.fusarium)}}
                                </mat-error>
                            </mat-form-field>
                        </div>
                        <div class="col-lg col-md">
                            <mat-form-field class="w-100" appearance="{{formFieldAppearance}}"
                                floatLabel="{{formFieldFloatLabel}}">
                                <mat-label class="InputLabelColor">Ataque de Besouros
                                    <span class="InputRequired">{{required}}</span></mat-label>
                                <input matInput id="txtAtqBesouro" #txtAtqBesouro maxlength="10"
                                    formControlName="ataque_besouros" currencyMask
                                    [options]="{ thousands: '.', decimal: ',', precision: 0 }">
                                <i matSuffix class="{{iconEnableField}}"></i>
                                <mat-hint align="start" class="InputLabelDetailsColor">{{hintNumber}}</mat-hint>
                                <mat-hint align="end">{{txtAtqBesouro.value.length}} / 10</mat-hint>
                                <mat-error>{{hasErrorFormControl(formulario.controls.ataque_besouros)}}
                                </mat-error>
                            </mat-form-field>
                        </div>
                    </div>

                    <div class="row pt-3">
                        <div class="col-lg col-md">
                            <mat-form-field class="w-100" appearance="{{formFieldAppearance}}"
                                floatLabel="{{formFieldFloatLabel}}">
                                <mat-label class="InputLabelColor">Viviparidade
                                    <span class="InputRequired">{{required}}</span></mat-label>
                                <input matInput id="txtViviparidade" #txtViviparidade maxlength="10"
                                    formControlName="viviparidade" currencyMask
                                    [options]="{ thousands: '.', decimal: ',', precision: 0 }">
                                <i matSuffix class="{{iconEnableField}}"></i>
                                <mat-hint align="start" class="InputLabelDetailsColor">{{hintNumber}}</mat-hint>
                                <mat-hint align="end">{{txtViviparidade.value.length}} / 10</mat-hint>
                                <mat-error>{{hasErrorFormControl(formulario.controls.viviparidade)}}
                                </mat-error>
                            </mat-form-field>
                        </div>
                        <div class="col-lg col-md">
                            <mat-form-field class="w-100" appearance="{{formFieldAppearance}}"
                                floatLabel="{{formFieldFloatLabel}}">
                                <mat-label class="InputLabelColor">Giberela
                                    <span class="InputRequired">{{required}}</span></mat-label>
                                <input matInput id="txtGiberela" #txtGiberela maxlength="10" formControlName="giberela"
                                    currencyMask [options]="{ thousands: '.', decimal: ',', precision: 0 }">
                                <i matSuffix class="{{iconEnableField}}"></i>
                                <mat-hint align="start" class="InputLabelDetailsColor">{{hintNumber}}</mat-hint>
                                <mat-hint align="end">{{txtGiberela.value.length}} / 10</mat-hint>
                                <mat-error>{{hasErrorFormControl(formulario.controls.giberela)}}
                                </mat-error>
                            </mat-form-field>
                        </div>
                        <div class="col-lg col-md">
                            <mat-form-field class="w-100" appearance="{{formFieldAppearance}}"
                                floatLabel="{{formFieldFloatLabel}}">
                                <mat-label class="InputLabelColor">Mortas
                                    <span class="InputRequired">{{required}}</span></mat-label>
                                <input matInput id="txtMortas" #txtMortas maxlength="10" formControlName="mortas"
                                    currencyMask [options]="{ thousands: '.', decimal: ',', precision: 0 }">
                                <i matSuffix class="{{iconEnableField}}"></i>
                                <mat-hint align="start" class="InputLabelDetailsColor">{{hintNumber}}</mat-hint>
                                <mat-hint align="end">{{txtMortas.value.length}} / 10</mat-hint>
                                <mat-error>{{hasErrorFormControl(formulario.controls.mortas)}}
                                </mat-error>
                            </mat-form-field>
                        </div>
                        <div class="col-lg col-md">
                            <mat-form-field class="w-100" appearance="{{formFieldAppearance}}"
                                floatLabel="{{formFieldFloatLabel}}">
                                <mat-label class="InputLabelColor">Popped Kernel
                                    <span class="InputRequired">{{required}}</span></mat-label>
                                <input matInput id="txtPopped" #txtPopped maxlength="10" formControlName="popped_kernel"
                                    currencyMask [options]="{ thousands: '.', decimal: ',', precision: 0 }">
                                <i matSuffix class="{{iconEnableField}}"></i>
                                <mat-hint align="start" class="InputLabelDetailsColor">{{hintNumber}}</mat-hint>
                                <mat-hint align="end">{{txtPopped.value.length}} / 10</mat-hint>
                                <mat-error>{{hasErrorFormControl(formulario.controls.popped_kernel)}}
                                </mat-error>
                            </mat-form-field>
                        </div>
                        <div class="col-lg col-md">
                            <mat-form-field class="w-100" appearance="{{formFieldAppearance}}"
                                floatLabel="{{formFieldFloatLabel}}">
                                <mat-label class="InputLabelColor">Ponto Dupla
                                    <span class="InputRequired">{{required}}</span></mat-label>
                                <input matInput id="txtPontoDupla" #txtPontoDupla maxlength="10"
                                    formControlName="ponto_dupla" currencyMask
                                    [options]="{ thousands: '.', decimal: ',', precision: 0 }">
                                <i matSuffix class="{{iconEnableField}}"></i>
                                <mat-hint align="start" class="InputLabelDetailsColor">{{hintNumber}}</mat-hint>
                                <mat-hint align="end">{{txtPontoDupla.value.length}} / 10</mat-hint>
                                <mat-error>{{hasErrorFormControl(formulario.controls.ponto_dupla)}}
                                </mat-error>
                            </mat-form-field>
                        </div>
                    </div>

                    <div class="row pt-3">
                        <div class="col-lg col-md">
                            <mat-form-field class="w-100" appearance="{{formFieldAppearance}}"
                                floatLabel="{{formFieldFloatLabel}}">
                                <mat-label class="InputLabelColor">Comentários</mat-label>
                                <textarea matInput id="txtComent" #txtComent maxlength="255"
                                    formControlName="comentarios"></textarea>
                                <mat-hint align="start" class="InputLabelDetailsColor"></mat-hint>
                                <mat-hint align="end">{{txtComent.value.length}} / 255</mat-hint>
                                <mat-error>{{hasErrorFormControl(formulario.controls.comentarios)}}</mat-error>
                            </mat-form-field>
                        </div>
                    </div>

                </mat-card-content>
            </form>
        </mat-card>
    </div>
</div>